import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Outlet, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import BoostFloralLogo from '../../app/components/svgIcons/BoostFloralLogo';
import BgPattern from './assets/images/BgPattren.png';
import StyledText from '../../app/components/styledComponents/StyledText';
import { Link } from 'react-router-dom';

const AuthOutlet = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.roles?.length > 0) {
      if (window.$redirectURL) {
        let pathInfo = window.$redirectURL;
        pathInfo = pathInfo.split('/');
        pathInfo.splice(3, 0, 'admin');
        pathInfo = pathInfo.join('/');
        window.$redirectURL = '';
        window.location.href = pathInfo;
      } else {
        if(user?.roles.some(
          (role) =>
            role?.id === 54 ||
            role?.name?.toLowerCase() === 'delivery driver' ||
            role?.name?.toLowerCase().includes('driver')
        )){
          navigate('/deliveries');
        }
        else if (user?.floristDTO?.completeInformation === false) {
          navigate('/onboarding');
        } else {
          navigate('/dashboard');
        }
      }
    }
  }, [user]);

  return (
    <StyledAuthWrapper className="d-flex justify-content-center flex-column min-vh-100 mt-5 mt-md-0">
      <div className="p-2 p-md-3 mt-5 mt-md-0">
        <a href="/">
          <BoostFloralLogo />
        </a>
      </div>

      <Outlet />

      <div className="flex-center justify-content-center my-3 flex-column">
        <div className="d-flex align-items-center gap-3 mb-3">
          <StyledText color="secondary" className="mb-0 fw-bolder">
            <Link
              to={`${process.env.REACT_APP_APP_URL}/privacy-policy`}
              className="footer-links"
            >
              Privacy Policy
            </Link>
          </StyledText>
          <div className="border border-left border-1 h-100" />
          <StyledText color="secondary" className="mb-0 fw-bolder">
            <Link
              to={`${process.env.REACT_APP_APP_URL}/terms-and-conditions`}
              className="footer-links"
            >
              {' '}
              Terms of Use{' '}
            </Link>
          </StyledText>
        </div>
        <p>
          ©{new Date().getFullYear()} Copyright BoostFloral. All rights
          reserved.
        </p>
      </div>
    </StyledAuthWrapper>
  );
};

const StyledAuthWrapper = styled.div`
  position: relative;
  background-image: ${({ excludeBg }) =>
    excludeBg ? 'none' : `url(${BgPattern})`};
  background-repeat: no-repeat;
  background-position: ${({ excludeBg }) =>
    excludeBg ? 'initial' : '86% -8%'};
  background-color: ${({ theme }) => theme.white};

  .auth-inner {
    background-image: ${BgPattern};
    box-shadow: 0 4px 40px rgba(0, 0, 0, 0.15);
    transition: all 0.3s;
    max-width: 950px;
    margin: 0 auto;
    padding: 20px;

    @media screen and (max-width: 768px) {
      max-width: 100%;
    }
  }
`;
export default AuthOutlet;
